<template>
  <span>
    <span ref="icon">
      <img @click="saveGPX" :style="{height: height + 'px', width: width || null, cursor: 'pointer'}" :src="icons.download" />
    </span>
    <!--<b-tooltip v-if="(rendered) && (window.isDesktop)" :target="$refs.icon">{{ $t('downloadGPX') }}</<b-tooltip>-->
  </span>  
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import {BaseBuilder, buildGPX} from 'gpx-builder';
import FileSaver from 'file-saver';
import GpsTrack from '@/ts/GpsTrack';
import { defineComponent, type PropType } from "vue";

export default defineComponent({
    extends: BaseComponent,
    data() {
        return {
            rendered: false
        };
    },
    mounted() {
        this.$nextTick(() => {
          this.rendered = true;
        })
    },
    methods: {
        saveGPX() {
            const segments = [];
            for (const segment of this.gpsTrack.segments) {
              const gpsPointList = [];
              for (const point of segment.pointsArray) {
                const gpsPoint = new BaseBuilder.MODELS.Point(point.lat, point.lng);
                gpsPointList.push(gpsPoint);
              }
              const gpxSegment = new BaseBuilder.MODELS.Segment(gpsPointList);
              segments.push(gpxSegment);
            }
            const gpxData = new BaseBuilder();
            gpxData.setMetadata(new BaseBuilder.MODELS.Metadata({name: this.gpsTrack.name}));
            gpxData.setTracks([new BaseBuilder.MODELS.Track(segments, {name: this.gpsTrack.name})]);
            const blob = new Blob([buildGPX(gpxData.toObject())], {type: 'text/plain;charset=utf-8'});
            FileSaver.saveAs(blob, this.gpsTrack.name + '.gpx');
        }
    },
    props: {
        gpsTrack: { required: true,
            type: Object as PropType<GpsTrack>
        },
        height: { required: true,
            type: Number
        },
        width: { required: true,
            type: String
        }
    }
})

</script>
